var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{key:_vm.status?.value,staticClass:"font-weight-bold text-center mt-1 mt-sm-2 text-no-wrap rounded-pill d-flex align-center",class:{
    'text-body-2': _vm.$vuetify.breakpoint.smAndUp,
    'text-caption': _vm.$vuetify.breakpoint.xsOnly,
  },staticStyle:{"padding":"3px 12px"},style:({
    'background-color': `${_vm.status?.color ?? _vm.color ?? '#FFFFFF'}33`,
    color: `${_vm.status?.color ?? _vm.color ?? '#FFFFFF'}`,
  })},[(_vm.icon)?_c('v-icon',{staticClass:"mr-2",attrs:{"small":true,"color":_vm.status?.color ?? _vm.color ?? _vm.$vuetify.theme.currentTheme.primary}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.status?.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }